import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RouteContext, RouteOutlet, filterByPermission, matchConfig, resolveConfig, routeConfig } from '@/routes';
import { layoutRegistry } from '@/layouts/registry';
/**
 * 应用外壳：
 *   配置树 -> 权限过滤 -> 静态展开 -> 按 pathname 匹配 -> 选布局 -> 渲染内容出口
 * 布局渲染在 Switch 之外，因此导航时不会重挂载 Navbar / Sider 及其状态。
 */

export default function AppShell() {
  const permissions = useSelector(state => state.userInfo?.permissions);
  const role = useSelector(state => state.userInfo?.role);
  const permissionsKey = JSON.stringify(permissions || {});
  const {
    pathname
  } = useLocation();
  const routes = useMemo(() => resolveConfig(filterByPermission(routeConfig, JSON.parse(permissionsKey), role)), [permissionsKey, role]);
  const match = useMemo(() => matchConfig(pathname, routes), [pathname, routes]);
  const Layout = layoutRegistry[match?.route.layout ?? 'base'];
  return /*#__PURE__*/React.createElement(RouteContext.Provider, {
    value: {
      match,
      routes,
      params: match?.params ?? {}
    }
  }, /*#__PURE__*/React.createElement(Layout, {
    match: match
  }, /*#__PURE__*/React.createElement(RouteOutlet, {
    routes: routes
  })));
}